// Affinity Kitchens
import * as _ from 'lodash'
import React, { useState } from 'react';
import { useJobCostItemDragDrop } from 'Scripts/draggableJobCostLineItem';
import valueFilters from 'Scripts/valueFilters';
import util from 'Scripts/util';
import { JobCostApplianceRowComponent } from './jobCostApplianceRow';
import { JobCostSetupRowsComponent } from './jobCostSetupRows';
import { CurrencyInput, jobCostRowOwner, JobCostHiddenWhenLocked, NumericInput, PercentInput } from 'Scripts/components/sharedComponents';
import keyboardUtil from 'Scripts/keyboardUtils';

const KEY_DOWN_CODES = [13];

export function JobCostSpecialGlassRow(props) {
	const { classNames = [], buttonClass, draggable, dropLineItem, lineItem, alwaysValidate, buttonHandler, updateModel } = props;
	const [shouldValidate, setShouldValidate] = useState(alwaysValidate);
	const [{isDragging, dragSourceRef, dragPreviewRef, dropItem, dropTargetRef, rowRef}] = useJobCostItemDragDrop({ 
		item: lineItem,
		handleDrop: (dragItem, dropItem) => dropLineItem(dragItem.key, dropItem.key) 
	});
	
	function handleUpdate (path, autoSave, e) {
		e.preventDefault();

		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;
		updateModel((model, updateCallback) => {
			model.setAt(path, newVal);

			updateCallback(model, path);
		}, { autoSave: autoSave });
	}

	function validate (property?) {
		if (!property || shouldValidate) {
			const result = !lineItem.test(property);
			return result;
		}
		return true;
	}

	function handleButtonClick (e) {
		e.preventDefault();
		
		const valid = validate();

		if (!valid) {
			setShouldValidate(true)
		}
		else {
			// this assumes that the add handler succeeds
			setShouldValidate(alwaysValidate);
		}

		buttonHandler(valid, e);
	}

	let dropClass = '';
	const dragClass = isDragging ? 'disabled' : '';

	if (dropItem) {
		const dropIndex = lineItem.sortIndex;
		const dragIndex = dropItem.sortIndex;
		dropClass = (dropIndex > dragIndex) ? 'dropBottom' : 'dropTop';
	}

	const disableEntry = lineItem.itemNote ? '' : 'disabled';
	const disableEntryReadOnly = lineItem.itemNote ? 'readOnly' : 'readOnly disabled';
	const rowClasses = _.concat(classNames, dropClass, dragClass);
	const dragHandle = (draggable) ? <button ref={ dragSourceRef } className="icon iconOnly drag"><span /></button> : null;

	return <tr ref={ rowRef } className={ rowClasses.join(' ') } key={lineItem.key}>
		<td />
		<td>{dragHandle}</td>
		<td className={(!validate('itemNote') ? 'required' : '')}>
			<input className={''} type="text" placeholder="Enter" autoCapitalize="" autoCorrect="off" 
				value={lineItem.viewValue('itemNote')} 
				onChange={ e => handleUpdate('itemNote', false, e)} 
				onBlur={ e => handleUpdate('itemNote', true, e)} 
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/></td>
		<td className={(!validate('orderNote') ? 'required' : '')}>
			<input className={disableEntry} type="text" placeholder="Enter" autoCapitalize="" 
				autoCorrect="off" value={lineItem.viewValue('orderNote')} 
				onChange={ e => handleUpdate('orderNote', false, e)} 
				onBlur={ e => handleUpdate('orderNote', true, e)} 
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className={'lwh' + ' ' + ((!validate('width') || !validate('height')) ? 'required' : '')}>
			<input className={disableEntry} type="text" placeholder="W" value={lineItem.viewValue('width')} 
				onChange={ e => handleUpdate('width', false, e)} 
				onBlur={ e => handleUpdate('width', true, e)}
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))} />
			<input className={disableEntry} type="text" placeholder="H" value={lineItem.viewValue('height')} 
				onChange={ e => handleUpdate('height', false, e)} 
				onBlur={ e => handleUpdate('height', true, e)} 
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/></td>
		<td><input className={disableEntry} type="text" placeholder="Enter" autoCapitalize="" autoCorrect="off" 
			value={lineItem.viewValue('description')} 
			onChange={ e => handleUpdate('description', false, e)} 
			onBlur={ e => handleUpdate('description', true, e)}
			onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))} /></td>
		<td className={'cost' + ' ' + (!validate('cost') ? 'required' : '')}>
			<CurrencyInput className={disableEntry} type="text" placeholder="Enter" autoCapitalize="" 
				autoCorrect="off" value={lineItem.viewValue('cost')} 
				onChange={ e => handleUpdate('cost', false, e)} 
				onBlur={ e => handleUpdate('cost', true, e)}
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className={'quantity' + ' ' + (!validate('quantity') ? 'required' : '')}>
			<NumericInput className={disableEntry} placeholder="0" min="0" 
				value={lineItem.viewValue('quantity')} 
				onChange={ e => handleUpdate('quantity', false, e)} 
				onBlur={ e => handleUpdate('quantity', true, e)}
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className={'cost'}><span className={disableEntryReadOnly}>{util.formatAsCurrency(lineItem.totalCost)}</span></td>
		<td className={'margin' + ' ' + (!validate('margin') ? 'required' : '')}>
			<PercentInput className={disableEntry} type="text" placeholder="20" 
				value={lineItem.viewValue('margin')} 
				onChange={ e => handleUpdate('margin', false, e)} 
				onBlur={ e => handleUpdate('margin', true, e)}
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className={'sell' + ' ' + (!validate('sellPrice') ? 'required' : '')}>
			<CurrencyInput className={disableEntry} type="text" placeholder="0.00" 
				value={lineItem.viewValue('sellPrice')} 
				onChange={ e => handleUpdate('sellPrice', false, e)} 
				onBlur={ e => handleUpdate('sellPrice', true, e)} 
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className="action"><button className={buttonClass} onClick={handleButtonClick}><span /></button></td>
		<td />
	</tr>;
}

export const JobCostSpecialGlassSection = jobCostRowOwner({ listAccessor: model => model.lineItems, listFilterThunkFactory: props => row => row.type === props.type }, class SpecialGlassSection extends React.Component<any, any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(this.props);

		this.dropLineItem = this.dropLineItem.bind(this);
	}

	getStateFromProps (props) {
		const state = _.assign({}, this.state);

		if (!state.pendingLineItem || state.pendingLineItem.type !== props.type) {
			state.pendingLineItem = this.createPendingLineItem(props);
		}

		return state;
	}

	addLineItemHandler (lineItemKey, isValid) {
		if (!isValid) {
			return;
		}

		this.props.updateModel(model => {
			if (lineItemKey === this.state.pendingLineItem.key) {
				this.state.pendingLineItem.sortIndex = this.props.getNextSortIndex(model);
				model.lineItems.add(this.state.pendingLineItem);
				this.props.sortRows(model);

				this.setState({ pendingLineItem: this.createPendingLineItem(this.props) });
			}
		}, { autoSave: true });
	}

	createPendingLineItem (props) {
		const { jobCost, type } = props;

		return jobCost.createLineItem({ type: type, margin: jobCost.margin, quantity: 1 });
	}

	updateModel (key, updater, options) {
		this.props.updateModel((jobCost, lineUpdateCallback) => {
			let lineItem = jobCost.lineItems.get(key);

			if ((!lineItem) && (key === this.state.pendingLineItem.key)) {
				lineItem = this.state.pendingLineItem;
				options.autoSave = false;
			}

			if (lineItem) {
				updater(lineItem, lineUpdateCallback);
			}
		}, options);
	}

	dropLineItem (sourceKey, targetKey) {
		this.props.updateModel(jobCost => {
			const sourceItem = jobCost.lineItems.get(sourceKey);
			const targetItem = jobCost.lineItems.get(targetKey);

			this.props.handleItemDrop(jobCost, sourceItem, targetItem);
		}, { autoSave: true });
	}

	render () {
		const { getRowClasses, jobCost, rowContextMenuHandler, type } = this.props;

		const lineItems = _.map(_.sortBy(jobCost.getLineItemsByType(type), 'sortIndex'), item => {
			return (
				<JobCostSpecialGlassRow key={item.rowKey} updateModel={this.updateModel.bind(this, item.key)} dropLineItem={ this.dropLineItem } buttonHandler={ rowContextMenuHandler.bind(this, item)} lineItem={item} classNames={ getRowClasses({ item: item }) } buttonClass="icon iconOnly contextMenu" draggable={true} alwaysValidate={true} workAreas={jobCost.workAreas} />
			);
		});

		return (<div className="inner">
			<table className="compact draggable" cellPadding="0" cellSpacing="0">
				<thead>
					<tr>
						<td />
						<td />
						<td><span className="readOnly">Type</span></td>
						<td><span className="readOnly">Supplier</span></td>
						<td className="lwh"><span className="readOnly">Approx. Size (WH)</span></td>
						<td><span className="readOnly">Cabinet Info</span></td>
						<td className="cost"><span className="readOnly">Unit Cost</span></td>
						<td className="centered quantity"><span className="readOnly">Quantity</span></td>
						<td className="cost"><span className="readOnly">Cost</span></td>
						<td className="margin"><span className="readOnly">Margin %</span></td>
						<td className="sell"><span className="readOnly">Sell</span></td>
						<td className="action" />
						<td />
					</tr>
				</thead>
				<tbody>
					<JobCostHiddenWhenLocked jobCost={ jobCost }><JobCostSpecialGlassRow key={this.state.pendingLineItem.key} updateModel={this.updateModel.bind(this, this.state.pendingLineItem.key)} buttonHandler={this.addLineItemHandler.bind(this, this.state.pendingLineItem.key)} lineItem={this.state.pendingLineItem} classNames={ ['addRow'] } buttonClass="icon iconOnly addItem" draggable={false} workAreas={jobCost.workAreas} /></JobCostHiddenWhenLocked>
					{ lineItems }
				</tbody>
			</table>
		</div>);
	}
});

export const JobCostApplianceRow = JobCostApplianceRowComponent;
export const JobCostSetupRows = JobCostSetupRowsComponent;
